// component
import LocationSelect from '@/components/location-select/index.vue';
import ProjectService from '../../publish-project-service.js';
import Service from '@/service/index.js';
import Bus from '../../../transaction-pro/bus.js';
import { mapGetters, mapMutations } from 'vuex';
import RegExpObj from '@/utils/regExp.js';
import { validateDate } from '@/utils/common.js';

export default {
  components: {
    LocationSelect
  },
  props: ['projectInfo'],
  computed: {
    ...mapGetters([
      'userInfo',
      'tradeType',
      'getTenantParams'
    ])
  },
  data() {
    const validateManagementSubjectCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择经营权主体'));
      } else if ((value === '4') && !this.ruleForm.managementSubject) {
        callback(new Error('请输入经营权主体信息!'));
      } else {
        callback();
      }
    };

    const validateStartTime = (rule, value, callback) => {
      if(!value) {
        callback(new Error('请选择开始日期'));
      } else if(validateDate(value, this.ruleForm.endTime)) {
        callback(new Error('结束日期不能早于开始日期'));
      } else {
        callback();
      }
    };
    const validateEndTime = (rule, value, callback) => {
      if(!value) {
        callback(new Error('请选择结束日期'));
      } else if(validateDate(this.ruleForm.startTime, value)) {
        callback(new Error('结束日期不能早于开始日期'));
      } else {
        callback();
      }
    };
    const validateDeliveryPeriod = (rule, value, callback) => {
      if(!value) {
        callback(new Error('请输入年限'));
      } else if(this.ruleForm.projectType === '6' || (this.ruleForm.projectType === '7' && this.ruleForm.projectSubType === '2')) {
        if(!RegExpObj.cbtime.test(value)) {
          callback(new Error('年限1-30年'));
        } else {
          callback();
        }
      } else {
        if(!RegExpObj.time.test(value)) {
          callback(new Error('年限1-70年'));
        } else {
          callback();
        }
      }
    };
    return {
      action: '/api/v1.0/chanquan/fast/uploadFile',
      headers: {},
      length: 0,
      areaCode: '',
      projectTypeArr: [],
      projectSubTypeArr: {}, // 项目分类
      tradeTypeArr: [],
      managementSubjectCodeArr: [],
      managementhouseholdSubjectCodeArr: [],
      landtypeArr: [], // 农户承包地的土地类别
      transfereeTypeArr: [],
      bidGeneralSituationArr: [],
      checked: false,
      dataShow: true,
      repriedDataText: '发包', // 发包期限
      date: [],
      deliveryPeriodMonthList: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'],
      projectTypeList: [],
      fileList: [],
      ruleForm: {
        projectType: '1',
        tradeType: '2',
        projectSubType: '', // 项目分类
        city: '',
        county: '',
        township: '',
        village: '',
        projectName: '',
        bidName: '',
        address: '',
        managementSubject: '',
        managementSubjectCode: '',
        landCategory: '',
        transferType: '', // 转让方式
        deliveryPeriod: '', // 发包年限
        startTime: '',
        endTime: '',
        transfereeType: '',
        purpose: '', // 受让用途
        file: [],
        fileData: '',
        projectAddress: '',
        deliveryPeriodUnit: '1' // 出租方式
      },
      labelVal: '经营权主体',
      addressText: '坐落位置',
      rules: {
        tradeType: [
          { required: true, message: '请选择交易方式', trigger: 'change' }
        ],
        purpose: [
          { required: true, message: '请选择受让用途', trigger: 'change' }
        ],
        projectType: [
          { required: true, message: '请选择项目类型', trigger: 'change' }
        ],
        projectSubType: [
          { required: true, message: '请选择项目分类', trigger: 'change' }
        ],
        bidName: [
          { required: true, message: '请输入标的名称', trigger: 'blur' }
        ],
        village: [
          { required: true, message: '请选择完整的坐落位置', trigger: 'change' }
        ],
        managementSubjectCode: [
          { required: true, validator: validateManagementSubjectCode, trigger: 'change' }
        ],
        deliveryPeriod: [
          { required: true, validator: validateDeliveryPeriod, trigger: 'change' }
        ],
        startTime: [
          { required: true, validator: validateStartTime, trigger: 'change' }
        ],
        endTime: [
          { required: true, validator: validateEndTime, trigger: 'change' }
        ]
      },
      address: '',
      projectName: '',
      cityList: [],
      districtList: [],
      townList: [],
      villageList: [],
      isInit: true,
      transferTypeArr: [],
      // 设置只能选择当前日期及之后的日期
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now(); // 如果没有后面的-8.64e7就是不可以选择今天的
        }
      },
      // 四荒可选择年限1~50年
      pickerOptions1: {
        disabledDate(time) {
          // 设置可选择的日期为今天之后的一个月内
          let curDate = (new Date()).getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          let day = 50 * (365 * 24 * 3600 * 1000);
          let dateRegion = curDate + day;
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion;
        }
      },
      pickerOptions: {
        disabledDate (time) {
          // 设置可选择的日期为今天之后的一个月内
          let curDate = (new Date()).getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          let day = 3 * 365 * 24 * 3600 * 1000;
          let dateRegion = curDate + day;
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion;
          // 设置选择的日期小于当前的日期,小于返回true,日期不可选
          // return time.getTime() < Date.now() - 8.64e7
        }
      },
      dialogVisible: false, // 选择受让人弹出框
      // 受让人信息
      assigneeInfo: {},
      personResForm: null,
      companyForm: null,
      deliveryPeriodUnitList: []
    };
  },
  watch: {
    projectInfo: 'projectInit',
    'ruleForm.projectSubType': function() {
      if((Number(this.ruleForm.projectType) === 1 || Number(this.ruleForm.projectType) === 3) && Number(this.ruleForm.projectSubType) === 1) {
        this.labelVal = '经营权主体';
      } else if(Number(this.ruleForm.projectType) === 2) {
        this.labelVal = '林地使用权人';
        if(Number(this.ruleForm.projectSubType) === 3) {
          this.labelVal = '转让方类型';
        }
      } else if((Number(this.ruleForm.projectType) === 6 || Number(this.ruleForm.projectType) === 7) && Number(this.ruleForm.projectSubType) === 1) {
        this.labelVal = '所有权主体';
      } else if(Number(this.ruleForm.projectType) === 4) {
        this.labelVal = '使用权主体';
      }

      if(Number(this.ruleForm.projectType) === 6 && Number(this.ruleForm.projectSubType) === 1) {
        this.repriedDataText = '出租';
      } else if(Number(this.ruleForm.projectType) === 1 && Number(this.ruleForm.projectSubType) === 2) {
        this.repriedDataText = '流转';
      } else {
        this.repriedDataText = '发包';
      }
      // 传参给other-from
      Bus.$emit('msg', this.ruleForm.projectType, this.ruleForm.projectSubType);
      this.$emit('modulesChoose', this.ruleForm.projectType, this.ruleForm.projectSubType, this.ruleForm.bidGeneralSituation);
    },
    // 当大类发生改变的时候 清空别的类的值
    'ruleForm.projectType': function() {
      this.ruleForm =  {
        ...this.ruleForm,
        // tradeType: '',
        projectSubType: '1',
        // 受让人信息
        // transfereeName: '',
        transfereeIdCard: '',
        transfereePhoneNo: '',
        creditCode: '',
        // transfereeType: '1',
        date: [],
        city: '',
        county: '',
        township: '',
        village: '',
        projectName: '',
        bidName: '',
        address: '',
        managementSubject: '',
        managementSubjectCode: '',
        landCategory: '',
        commonOwnershipDesc: '', // 共有权人
        woodlandUser: '', // 林地使用权人
        forestOwner: '',  // 所有权人
        forestUser: '',   // 使用权人
        transferType: '1', // 转让方式
        transfereeId: '', // 受让人ID
        transfereeName: '',
        transfereeType: '',
        deliveryPeriod: '', // 发包年限
        startTime: '',
        endTime: '',
        deliveryPeriodUnit: '1' // 出租方式 年或者月
      };
      this.areaCode = this.getTenantParams.areaCode;
      // 如果说当前大类的typeid和返回的typeid一致 则重新调用projectInfo方法获取basic的val
      if(Number(this.ruleForm.projectType) === Number(this.projectInfo.projectType)) {
        this.projectInit();
      } else {
        this.getcityInfo();
      }
      if((Number(this.ruleForm.projectType) === 1 || Number(this.ruleForm.projectType) === 3) && Number(this.ruleForm.projectSubType) === 1) {
        this.labelVal = '经营权主体';
      } else if(Number(this.ruleForm.projectType) === 2 && Number(this.ruleForm.projectSubType) === 1) {
        this.labelVal = '林地使用权人';
      } else if((Number(this.ruleForm.projectType) === 6 || Number(this.ruleForm.projectType) === 7) && Number(this.ruleForm.projectSubType) === 1) {
        this.labelVal = '所有权主体';
      } else if(Number(this.ruleForm.projectType) === 4) {
        this.labelVal = '使用权主体';
      }
      if(Number(this.ruleForm.projectType) === 7 && Number(this.ruleForm.projectSubType) === 1) {
        this.addressText = '存放位置';
      } if(Number(this.ruleForm.projectType) === 6) {
        this.addressText = '项目位置';
      } else {
        this.addressText = '坐落位置';
      }
      Bus.$emit('msg', this.ruleForm.projectType, this.ruleForm.projectSubType);
      this.$emit('modulesChoose', this.ruleForm.projectType, this.ruleForm.projectSubType);

      if(Number(this.ruleForm.projectType) === 6 && Number(this.ruleForm.projectSubType) === 1) {
        this.repriedDataText = '出租';
      } else if(Number(this.ruleForm.projectType) === 1 && Number(this.ruleForm.projectSubType) === 2) {
        this.repriedDataText = '流转';
      } else {
        this.repriedDataText = '发包';
      }

      // 设备不展示发包期限
      // if(Number(this.ruleForm.projectType) === 7 && Number(this.ruleForm.projectSubType) === 1) {
      //   this.dataShow = false;
      // } else {
      //   this.dataShow = true;
      // }
      // 如果是农村集体经济组织用户 就默认选中
      if(this.userInfo.type === 3) {
        this.ruleForm.managementSubjectCode = '1';
      }
    },
    'ruleForm.transferType': function(value) {
      this.SET_TRANSFER_TYPE(value);
      Bus.$emit('msg', this.ruleForm.projectType, this.ruleForm.projectSubType, this.ruleForm.landCategory, value);
    },
    // 交易方式
    'ruleForm.tradeType': function(value) {
      value && this.SET_TRADE_TYPE(value);

      // 公开交易
      if(Number(value) === 1) {
        this.ruleForm = {
          ...this.ruleForm,
          transfereeId: '',
          transfereeName: '',
          transfereeType: ''
        };
        this.companyForm = null;
        this.personResForm = null;
      }
    },
    // 林地使用权人
    'ruleForm.woodlandUser': function(value) {
      this.ruleForm.woodlandUser = value.replace(/[^A-Za-z0-9\u4e00-\u9fa5]/g, '');
    },
    // 标的名字 只可以输入汉字、数字、字母
    'ruleForm.bidName': function(value) {
      this.ruleForm.bidName = value.replace(/[^A-Za-z0-9\u4e00-\u9fa5]/g, '');
    },
    // 林木所有权人 只可以输入汉字、数字、字母
    'ruleForm.forestOwner': function(value) {
      this.ruleForm.forestOwner = value.replace(/[^A-Za-z0-9\u4e00-\u9fa5]/g, '');
    },
    // 林木使用权人 只可以输入汉字、数字、字母
    'ruleForm.forestUser': function(value) {
      this.ruleForm.forestUser = value.replace(/[^A-Za-z0-9\u4e00-\u9fa5]/g, '');
    },
    'ruleForm.deliveryPeriod': function(value) {
      if(value) {
        this.ruleForm.deliveryPeriod = String(value);
      }
      Bus.$emit('deliveryPeriod', value);
    },
    // 农机设备出租  出租方式
    'ruleForm.deliveryPeriodUnit': function(value, oldValue) {
      if (oldValue) {
        this.ruleForm.deliveryPeriod = '';
      }
    },
    // 标的情况
    'ruleForm.bidGeneralSituation': function(value) {
      Bus.$emit('bidGeneralSituationChange', value);
    }

  },
  created () {
    const token = this.userInfo.accessToken;
    const tId = this.getTenantParams.tId; // 租户id,跟区域相关
    if (token) {
      this.headers['Authorization'] = token;
      this.headers['TENANT-ID'] = tId;
    }

    // 转让方式 默认整体交易
    this.ruleForm.transferType = '1';
    // this.ruleForm.tradeType = String(this.tradeType);

    const arr = [
      ['projectTypeArr', 'PROJECT_TYPE'], ['tradeTypeArr', 'TRADE_TYPE'],
      ['managementSubjectCodeArr', 'MANAGEMENT_SUBJECT'], ['transfereeTypeArr', 'TRANSFEREE_TYPE'],
      ['landtypeArr', 'LAND_CATEGORY'], ['managementhouseholdSubjectCodeArr', 'MANAGEMENT_HOUSEHOLD_SUBJECT'],
      ['bidGeneralSituationArr', 'BID_GENERAL_SITUATION'],
      ['transferTypeArr', 'TRANSFER_TYPE'],
      ['deliveryPeriodUnitList', 'DELIVERY_PERIOD_UNIT'],
      ['projectSubTypeArr', 'BACTH_PROJECT_TYPE']
    ];

    // 根据用户类型展示不同 经营权主体
    const managementListByUserType = {
      '1': ['3', '4'],
      '2': ['2', '5', '4'],
      '3': ['1']
    };
    let currentMangementList = managementListByUserType[this.userInfo.type];
    // 如果是农村集体经济组织用户 就默认选中
    if(this.userInfo.type === 3) {
      this.ruleForm.managementSubjectCode = '1';
    }
    arr.forEach((value) => {
      if (!value.length) {
        return;
      };
      Service.getSelectList(value[1]).then(res => {
        if (res && res.code === '0') {
          this[value[0]] = res.data;
          // console.log(this.projectSubTypeArr);
          this.tradeTypeArr = this.tradeTypeArr.filter(item => item.code === String(2));
          // console.log(this.tradeTypeArr);
          this.managementSubjectCodeArr = this.managementSubjectCodeArr.filter(item => currentMangementList.includes(item.code));
          if (Number(this.tradeType) === 3) {
            this.projectTypeArr = this.projectTypeArr.filter(item => {
              if( item.code === '1') {
                return item;
              }
            });
          }
        }
      });
    });
    // 受让用途
    Service.getSelectList('TRANSFEREE_PURPOSE').then(res => {
      if (res && res.code === '0') {
        this.projectTypeList = res.data;

      }
    });
    this.id = this.$route.query.id;
  },
  mounted() {
    this.getcityInfo();
    if(this.id) {
      this.fileList=[{
        'name': '批量协议文件',
        'url': this.projectInfo.excelPath
      }];
      // this.ruleForm.fileData = '文件地址';
      // console.log(this.projectInfo.excelPath, 111);
      // this.$emit('filePath', this.projectInfo.excelPath);
    }
  },
  methods: {
    ...mapMutations([
      'SET_TRADE_TYPE',
      'SET_TRANSFER_TYPE'
    ]),
    // 农户承包地土地类别更换时
    agreeChange() {
      Bus.$emit('msg', this.ruleForm.projectType, this.ruleForm.projectSubType, this.ruleForm.landCategory, this.ruleForm.transferType);
    },
    clear() {
      this.date = null;
    },
    // 获取basicfrom的val 渲染页面
    projectInit() {
      // 如果是协议交易 并且受让人ID不为空
      if (Number(this.tradeType) === 2 && this.projectInfo.transfereeId) {
        this.getUserInfoById(this.projectInfo.transfereeId);
      }
      Object.keys(this.ruleForm).forEach((key) => {
        if (this.projectInfo && this.projectInfo[key] && ((typeof this.projectInfo[key] === 'string') || (typeof this.projectInfo[key] === 'number'))) {
          this.ruleForm[key] = this.projectInfo && String(this.projectInfo[key]);
          if(key === 'projectName') {
            this.address = this.projectInfo.insectionResForm.address.split(' ')[1]+this.projectInfo.insectionResForm.address.split(' ')[2]+this.projectInfo.insectionResForm.address.split(' ')[3]+this.projectInfo.insectionResForm.address.split(' ')[4];
            var regexp = new RegExp(this.address); // 获取项目名称后面输入框的内容
            var replaceStr = this.projectInfo.projectName.replace(regexp, '');
            this.ruleForm.bidName = replaceStr; // 输入input的value
          }
        }
      });
      if(Number(this.ruleForm.projectType) === Number(this.projectInfo.projectType)) {
        this.isInit = true;
      }
      if(!this.isInit) {
        setTimeout(() => {
          this.areaCode = this.ruleForm.village;
        }, 500);
      } else {
        this.areaCode = this.ruleForm.village;
        this.isInit = false;
      }
      // 综合类 标的情况展示
      if(this.projectInfo && this.projectInfo.assetsInfo && Number(this.projectInfo.projectType) === 8) {
        let list = JSON.parse(this.projectInfo.assetsInfo);
        let _tempArr = [];
        list.map(item => {
          if(item.bidGeneralSituation) {
            _tempArr.push(String(item.bidGeneralSituation));
          }
        });
        this.ruleForm.bidGeneralSituation = _tempArr;
      }
      this.date = [this.ruleForm.startTime, this.ruleForm.endTime];
    },
    // 获取项目子类集合
    selectChanged(val) {
      // this.projectSubTypeArr = {};
      this.projectTypeArr.forEach(item => {
        if(item.code === val) {
          this.projectSubTypeArr = item;
        }
      });
      this.$emit('form-clear');
    },
    // 获取注册时候位置信息
    getcityInfo() {
      ProjectService.getUserBaseInfo().then(res => {
        if(res && res.code === '0') {
          if(this.areaCode === res.data.county) {
            this.areaCode = res.data.village;
            this.address = res.data.addressDetail.split(' ')[1]+res.data.addressDetail.split(' ')[2]+res.data.addressDetail.split(' ')[3]+res.data.addressDetail.split(' ')[4];
            if(Number(this.ruleForm.projectType) === Number(this.projectInfo.projectType)) {
              if( this.projectInfo.projectName ) {
                var regexp = new RegExp(this.address); // 获取项目名称后面输入框的内容
                var replaceStr = this.projectInfo.projectName.replace(regexp, '');
                this.ruleForm.bidName = replaceStr; // 输入input的value
              }
            }
          }
        }
      });
    },
    areaCodeChange(event) {
      const key = event && event.type;
      this.ruleForm[key] = event.areaCode;
      this.areaCode = event.areaCode;

      setTimeout(() => {
        const childRef = this.$refs['locationSelect'] && this.$refs['locationSelect'].$refs;
        if(childRef) {
          this.address = Object.keys(childRef).reduce((current, item) => {
            return current += childRef[item].selectedLabel;
          }, '');
        }
        const address = Object.keys(childRef).reduce((current, item) => {
          return current += childRef[item].selectedLabel;
        }, '');
        if (!new RegExp('[0-9]').test(address)) {
          this.address = address;
        }
        this.ruleForm.projectAddress = this.address;
        this.length = 50 - this.address.trim().length;
      }, 500);
    },
    onChangeDate (event) {
      this.ruleForm.startTime = event && event[0];
      this.ruleForm.endTime = event && event[1];
    },
    // 受让人信息
    changeAssigneeInfo(assigneeInfo, personResForm, companyForm) {
      this.ruleForm = {
        ...this.ruleForm,
        ...assigneeInfo
      };
      this.personResForm = personResForm;
      this.companyForm = companyForm;
      this.dialogVisible = false;
    },
    // 根据用户ID获取用户信息
    getUserInfoById(userId) {
      ProjectService.getUserInfoById(userId).then(({ code, data }) => {
        if(code === '0' && data) {
          this.personResForm = data.personResForm;
          this.companyForm = data.companyForm;
        }
      });
    },
    // 文件上传成功
    handleUpSuccess(response, file) {
      let params = new FormData();
      params.append('file', file.raw);
      this.$emit('upload', params);
      // this.ruleForm.file = params;
      this.ruleForm.fileData = file.name;
    },
    handleUpRemove() {
      this.ruleForm.fileData = '';

    },
    beforeUpload(file) {
      var testmsg=file.name.substring(file.name.lastIndexOf('.')+1);
      const extension = testmsg === 'xls';
      const extension2 = testmsg === 'xlsx';
      const isLt2M = file.size / 1024 / 1024;
      // console.log(file);
      if(!extension && !extension2) {
        this.$message({
          message: '上传文件只能是 xls、xlsx格式!',
          type: 'error',
          duration: 1000,
          offset: 327
        });
      }
      if(isLt2M > 1) {
        this.$message({
          message: '上传文件大小不能超过 1MB!',
          type: 'error',
          duration: 1000,
          offset: 327
        });
      }
      return (extension || extension2) && isLt2M;
    },
    test() {
      // 重新选择项目位置的基础下
      this.ruleForm.projectName = (this.address + this.ruleForm.bidName).replace(/\s+/g, ''); // 需要传给后台的projectName
      return new Promise((resolve, reject) => {
        this.$refs['basicForm'].validate((valid) => {
          if (valid) {
            // console.log(this.ruleForm, 'this.ruleForm');
            resolve(JSON.parse(JSON.stringify(this.ruleForm)));
          } else {
            reject();
          }
        });
      });
    },
    // 下载模版
    downTemplate() {
      window.open('/批量发布项目模板.xlsx');
    }
  }
};
